import { ReactNode } from "react";
import { Card } from "react-bootstrap";

type Societa = {
    idSocieta: number,
    nomeSocieta: string
}

export type CardItem = {
    id: string | number;
    header?: ReactNode;
    title?: string | ReactNode;
    subtitle?: string | ReactNode;
    image?: string;
    altImageText?: string;
    content: ReactNode;
    html?: string | JSX.Element;
    footer?: ReactNode;
    link?: string;
    linkTitle?: string;
    idCategoria?: number;
    societa?: Societa[];
};

type Props = {
    id: string;
    cards: Array<CardItem>;
    cardBody: (card: CardItem) => ReactNode;
}

export default function CustomCard(props: Props) {
    const {cards, cardBody} = props;

    return <>
        {cards.length ? cards.map((card: CardItem, index:number) => {
            let {id, header, footer} = card;

            return <Card key={index} id={`${props.id}_${(id ? id : String(index))}`}>
                {header && <Card.Header>
                    {header}
                </Card.Header>}
                <Card.Body className="px-2">
                    {cardBody(card)}
                </Card.Body>
                {footer && <Card.Footer>
                    {footer}
                </Card.Footer>}
            </Card>
        }) : <div>Nessuna card da visualizzare</div>}
    </>
}
